<template>
      <div class="dsCard" :class="cssclassname" 
      
      
      >

        <div class="d_notofication_list">
                        <div class="notification_left">
             <avatar :size="36" :backgroundColor="'#fff'" :color="'#000'" :initials="avtarName(item, 'title')" ></avatar>
                        </div>
                        <div class="notification_right">
                            <div class="list_details">
                                <div>
                                    <h4>{{title}}</h4>
                                    <h5>{{role}}</h5>
                                </div>
                               
                            </div> 
                       
                        </div>
                             </div>
                             <div style="margin-top:10px; padding-bottom:10px; text-align:center" class="documentsList" v-if="casetracking">

  <img width="50" src="@/assets/images/tracking.png" />

                             </div>
                              <div style="padding-top:10px; padding-bottom:10px; margin-bottom:10px; text-align:center; background-color:#fff;" class="documentsList" v-if="petitioner">

  <img width="120" src="https://innvectra.com/wp-content/themes/innvectra/dist/images/inv_blue_logo.png" />

                             </div>
                                  <div style="margin-top:10px; padding-bottom:10px; text-align:center" class="documentsList" v-if="document">

  <img width="50" src="@/assets/images/party-popper.png" />

                             </div>
                             <p>{{content}}</p>
                             <div style="margin-top:-10px; padding-bottom:10px;" class="documentsList" v-if="document">

                               <ul>

                                 <li style="line-height:20px; display:flex;">
                                   <span style="margin-top:10px; position:absolute;"> <img width="20" src="@/assets/images/file.png" />  </span>
                                  <span style="line-height:35px;padding-left:30px;">  CASE 1234523456 Approval </span>
                                 </li>

                                 <li style="line-height:20px; display:flex;">
                                   <span style="margin-top:10px; position:absolute;"> <img width="20" src="@/assets/images/file.png" />  </span>
                                  <span style="line-height:35px;padding-left:30px;">  CASE 1234523456 Approval 2</span>
                                 </li>
                               </ul>

                             </div>
                                <div class="list-actions" v-if="action">
          <vs-dropdown vs-custom-content vs-trigger-click>

                                       <vs-button
              color="primary"
          class="light-blue-btn"
              type="border"
              icon-pack="feather"
              icon="icon-chevron-down"
              icon-after
            >Actions</vs-button>

                        <vs-dropdown-menu ref="filter_menu" class="actions-content petition-action-content">

<ul>
<li> Approve </li>
<li> Reject </li>

</ul>

                        </vs-dropdown-menu>
          </vs-dropdown>
                                </div>
                 
                                    <span>2 Min Ago</span> 

            

        </div>
</template>

<script>
import Avatar from 'vue-avatar'

export default {
        components: {
        Avatar
    },
    
  props: {
    casetracking:{
      type: Boolean,
      default:false,
    },
       petitioner:{
      type: Boolean,
      default:false,
    },
    document:{
      type: Boolean,
      default:false,
    },
    action:Boolean,
      item:Object,
         role:{
      type: String
    },
      title:{
      type: String
    },
            content: {
      type: String,
      default: "Lorem Ipsum is simply dummy text of the printing and typesetting industry."
    },
        cssclassname: {
      type: String,
      default: "color1d"
    }
  }
};
</script>